$.each($('.client-switcher--modal'), function() {
    let modalWatcher = $(this),
        /**
         * @property current_client
         * @property input_select_client
         * @property input_select_client__submit
         * @namespace clientData
         */
        clientData = modalWatcher.data('client-switcher-data')

    ;
    // console.log('clientData', clientData);
    modalWatcher.on('show.bs.modal', function() {
        //			let button = $(event.relatedTarget); // Button that triggered the modal

        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods
        // instead.
        let modalWindow = $(this);

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            }
        });
        $.ajax({
            url: clientData.url,
            dataType: 'json',
            data: {},
            success: function(data) {
                let
                    currentClient = clientData.current_client || [],
                    targetSelectElement = $('#' + clientData.input_select_client),
                    modalBody = modalWindow.find('.modal-body'),
                    modalProgressLoader = modalWindow.find('.md-progress'),
                    selectClientButton = $('#' + clientData.input_select_client__submit),

                    parentButtonsWrapper = selectClientButton.parent('.client-switcher--modal-buttons');

                if (modalProgressLoader.length > 0) {
                    modalProgressLoader.animate({
                        opacity: 0,
                        margin: 0
                    }, 1000);
                }

                // console.log('success', 'modalWindow.find(.close)',modalWindow.find('.close'));
                // console.log('success', 'modalWindow.find(.close)',modalWindow.find('md-progress'));

                if (targetSelectElement.length > 0) {
                    targetSelectElement.material_select('destroy');
                    targetSelectElement.remove();
                }

                let id = (
                        'title' in currentClient
                    ) ? currentClient.id : null,
                    notSelected = id === null ? 'selected' : null,
                    content = `<option value="" disabled ${notSelected}>Select </option>`,
                    materialSelectElement = $('<select/>').attr('id', clientData.input_select_client).append(content);

                $.each(data, function(i, val) {
                    
                    // console.log('val',val);
                    if(val.status == 'active'){
                        // populate the select with clients
                        let selected = (
                            id === val.id ? 'selected' : ''
                        );
                        content = `<option data-slug="${val.slug}" value="${val.id}" ${selected}>${val.title}</option>`;
                        materialSelectElement.append(content);
                    }

                });

                modalBody.append(materialSelectElement);

                materialSelectElement.material_select();
                initWatcher();

                function hasValue() {
                    //					console.log('materialSelectElement', materialSelectElement);
                    let selected = materialSelectElement.find(':selected').val().trim() || null,
                        slug = materialSelectElement.find(':selected').attr('data-slug').trim() || null,
                        link = selectClientButton.attr('href').trim()
                    ;

                    let selectData = {
                        slug: slug,
                        link: link,
                        selected: selected
                    };

                    if (selected !== null && slug !== null) {
                        return selectData;
                    }
                    else {
                        return {};
                    }
                }

                function initWatcher() {
                    // init watcher for the select change
                    materialSelectElement.change(function() {
                        // console.log('$(this)', $(this));
                        let separationElements = parentButtonsWrapper.data('separation-elements');
                        if (!_.isEmpty(hasValue())) {
                            selectClientButton
                                .addClass('d-block')
                                .removeClass('d-none');
//                            parentButtonsWrapper
//                                .removeClass(separationElements)
//                                .addClass('justify-content-between');
                        }
                        else {
                            selectClientButton
                                .removeClass('d-block')
                                .addClass('d-none');
//                            parentButtonsWrapper
//                                .removeClass('justify-content-between')
//                                .addClass(separationElements);

                        }
                    });
                    // console.log('$(\'#\' + clientData.input_select_client__submit)', $('#' +
                    // clientData.input_select_client__submit));
                    $(selectClientButton).click(function(e) {
                        e.preventDefault();
                        let selectData = hasValue();
                        //console.log('selectClientButton', 'selectData',selectData);
                        if (_.isEmpty(selectData)) {
                            console.error('selectData Empty', selectData);
                        }
                        else {
                            window.location = `${selectData.link}?id=${selectData.selected}&slug=${selectData.slug}`;
                        }

                    });

                }
            }
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/operations/client-switcher.js